module.exports = __webpack_public_path__ + "static/blog-img2-75d2261b1ab5aca0ed510c6e33cecaca.jpg";